import React, { FC } from 'react';

import { ChildrenPropType } from 'src/utils/types';
import { UiSpinner } from 'src/components/UI/Spinner';

type Props = {
  children: ChildrenPropType;
};

export const OverlayDummyContent: FC<Props> = ({ children }) => (
  <div className="campaign-management-overlay-content campaign-management-dummy-content">
    <div className="loading-spinner-container">
      <UiSpinner />
    </div>

    <div className="campaign-management-overlay-header" />
    <div className="campaign-management-overlay-scrolling-container">{children}</div>
  </div>
);
